
import FormData from "csi/action/FormData";
import { Context } from "csi/def/Context";
import ValuesStore from "csi/store/Values";
import NewFrom from "csi/table/NewFrom";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const NewStylePartMaterialFromThemeBOMController = declare(NewFrom, {

	_themeBOMSysIDStore: null,

	/**
	 * Add hook into form data to determine if the Theme PartMaterial node is already selected
	 * @override
	 */
	getFormData() {
		const fd = this.inherited<FormData>(arguments);
		fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
		return fd;
	},

	/**
	 * Determine if Style Placement SysID has already in the existing Theme PartMaterial.ThemeBOMSysID
	 * @override
	 */
	_isPreSelected(ctx: Context, fd: FormData) {
		return !!this._themeBOMSysIDStore.get(ctx.getNode().SysID);
	},

	/**
	 * Add any requests necessary to fetch data before executing action
	 * @override
	 */
	_preAction() {
		this._themeBOMSysIDStore = new ValuesStore({
			typeNode: "PartMaterial",
			requestParameters: {
				"Qry.Limit.Path": xml.getUrlPath(this.getParentURL(), xml.path("Items")),
				"Qry.Value.Attr": "ThemeBOMSysID",
			},
		});

		return this._themeBOMSysIDStore.query();
	},

	/**
	 * Add section as request param
	 * @override
	 */
	toWriterRequest: function () {
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("DSSection", xml.ATTR_REF, this.m_formData.m_source.m_nodeSource.DSSection);
		return call;
	},
});

export = NewStylePartMaterialFromThemeBOMController;
